export default function updateProp(state, [prop, value, prop2]) {
  if (prop2) {
    state[prop][prop2] = value;
  } else {
    state[prop] = value;
  }
}
